import { useParams, useHistory } from 'react-router-dom';
import { decodeBase64 } from '../utils/encodeBase64';
import routes from '../utils/commonVariables/routes';

const useEncodedUrlId = (key: string) => {
    const params = useParams<{ [key: string]: string | undefined }>();
    const history = useHistory();
    const encodedValue = params[key];

    try {
        if (!encodedValue) throw new Error('Missing param');
        return decodeBase64(encodedValue);
    } catch (error) {
        history.push(routes.pageNotFound);
        return null;
    }
};

export default useEncodedUrlId;
